import { Button, Stack, Box, Slide, Slider, styled } from "@mui/material";
import React, { useEffect } from "react";
import { Color, FontStyle } from "../constants";

const styles = {
  customMark: {
    position: "absolute",
    borderRadius: "50%",
    width: "0.5rem",
    height: "0.5rem",
    backgroundColor: "#fff",
    border: `2px solid ${Color.bgMed}`,
    zIndex: 1,
    top: "11px",
  },
};

const PrettoSlider = styled(Slider)({
  color: "#52af77",
  height: 3,
  "& .MuiSlider-track": {
    border: "none",
    color: Color.bgMed,
  },
  "& .MuiSlider-rail": {
    border: "none",
    color: Color.bgMed,
    opacity: 1,
  },
  "& .MuiSlider-thumb": {
    height: 18,
    width: 18,
    backgroundColor: "#fff",
    border: `4px solid ${Color.primary}`,
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
    zIndex: 2,
  },
  "& .MuiSlider-mark": {
    display: "none",
  },
  "& .MuiSlider-markLabel": {
    ...FontStyle.body,
    color: "#999",
    fontSize: "0.75rem",
    top: "25px",
    transform: "translateX(-44%)",
  },
});
const EmailSlider = ({ defaultValue, setValue, value }) => {
  useEffect(() => {
    console.log("value", value);
  }, [value]);
  return (
    <Box sx={{ maxWidth: "300px", width: "100%", position: "relative" }}>
      <Box sx={{ ...styles.customMark, left: 0 }} />
      <Box sx={{ ...styles.customMark, left: "50%" }} />
      <Box sx={{ ...styles.customMark, right: 0 }} />
      <PrettoSlider
        // defaultValue={
        //   defaultValue === null || defaultValue === undefined ? 0 : defaultValue
        // }
        value={value === null || value === undefined ? 0 : value}
        onChange={(e, val) => {
          setValue(val);
        }}
        // value={tempValue === null || tempValue === undefined ? 0 : tempValue}
        // onChange={(e, val) => {
        //   console.log("val", val);
        //   setTempValue(val);
        // }}
        size="small"
        min={0}
        max={2}
        step={1}
        marks={[
          { value: 0, label: "Never" },
          { value: 1, label: "Weekly" },
          { value: 2, label: "Daily" },
        ]}
      />
    </Box>
  );
};

export default EmailSlider;
